import { render, staticRenderFns } from "./ProfileOverview.vue?vue&type=template&id=4fc8cc0f&scoped=true"
import script from "./ProfileOverview.vue?vue&type=script&lang=js"
export * from "./ProfileOverview.vue?vue&type=script&lang=js"
import style0 from "./ProfileOverview.vue?vue&type=style&index=0&id=4fc8cc0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc8cc0f",
  null
  
)

export default component.exports